export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
		},
	],
	singular_model_name_spanish: '',
	plural_model_name_spanish: 'es',
	create_model_name_spanish: 'Nueva ',
	text_delete: 'la',
}